import React from 'react'
import styled from 'styled-components';
import StoryItem from './storyItem';



const StoryGrid = ({stories, title, subtitle}) => {

  return (
      <>
      {title && <Title>{title}</Title>}
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
      <StoriesWrapper>
        {stories.map((story,index) => (
          <StoryItem 
            key={story.id} 
            story={story}
            lazyLoadImg={index > 9}
          />
        ))}
      </StoriesWrapper>
    </>
  )
}

export default StoryGrid

const Subtitle = styled.h2`
  font-size:12px;
  font-family: 'Poppins';
  margin: 0px;
  margin-bottom: 20px;
  
`

const Title = styled.h3`
  font-size:24px;
  margin: 0px 0px;
`


const StoriesWrapper = styled.div`
  --padding: 20px;
  --gap: 10px;
  
  display: grid;
  grid-template-columns: repeat(
    auto-fill, 
    minmax(
      min(calc((100% - var(--padding) * 2 - var(--gap)) / 2), 200px),
      1fr
    )
  );
  gap: var(--gap);
  margin: 0 auto;
  padding: var(--padding);

  @media (max-width: 480px) {
    --padding: 10px;
    --gap: 8px;
  }
`;